import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

// Interface for Link component props
export interface LinkProps extends Omit<RouterLinkProps, 'to'> {
  href: string;
  children: React.ReactNode;
  className?: string;
  target?: '_blank' | '_self' | '_parent' | '_top' | string;
}

/**
 * Link component for client-side navigation, similar to Next.js Link.
 * Uses react-router-dom under the hood.
 */
export const Link: React.FC<LinkProps> = ({ href, children, className = '', target, ...props }) => {
  return (
    <RouterLink to={href} className={`hover:underline transition-colors ${className}`} {...props} target={target}>
      {children}
    </RouterLink>
  );
};

export default Link;
